module.exports = __webpack_public_path__ + "img/icon_home_anjian.23a4cf77.png";